import { formatCountdown, cn } from '@/utils'
import { useAtomValue } from 'jotai'

import { momentAtom } from '@/store/moment.store'

export function TransportCountdown() {
  const moment = useAtomValue(momentAtom)

  return (
    <span
      className={cn(
        'font-mono text-xl whitespace-nowrap',
        moment?.running && moment && moment?.left < 0 && 'text-red-400',
      )}
    >
      {formatCountdown(moment?.left || 0, '+')}
    </span>
  )
}
